import { motion } from "framer-motion";
import useSiteContent from "../hooks/useSiteContent";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8 },
};

export const Positioning = () => {
  const cms = useSiteContent();
  const p = cms.positioning || {};
  return (
    <section data-testid="positioning-section" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10 items-baseline">
        <motion.div {...fadeUp} className="lg:col-span-3">
          <p className="label-editorial text-clay">{p.kicker || "Quem somos"}</p>
        </motion.div>
        <motion.div {...fadeUp} className="lg:col-span-9">
          <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-tight max-w-4xl">
            {p.heading_before || "A INN.PACT é uma clínica de imagem que une"}{" "}
            <span className="italic text-clay">{p.heading_highlight || "visagismo"}</span>
            {p.heading_after || ", hairstyling e consultoria para revelar a melhor versão de si."}
          </h2>
          <p className="mt-8 max-w-2xl text-black/60 font-light leading-relaxed text-base md:text-lg whitespace-pre-line">
            {p.paragraph || "Cada pessoa é diferente, por isso não há duas consultas iguais. Antes de mexer no seu visual, sentamo-nos consigo, olhamos para o seu rosto, o seu tipo de cabelo e o seu dia-a-dia. Só depois decidimos o que fazer. É esta a diferença entre um corte e uma imagem que é mesmo sua."}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
